// tslint:disable-next-line:no-any
export const isUniqueMessage = (text: string, messages: any) => {
    // tslint:disable-next-line:no-console
    var output = true;
    // tslint:disable-next-line:no-any
    messages.forEach((mess: any) => {
        if (mess.text === text) {
            output = false;
        }
    });
    return output;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Messages.tsx